import { jsxs as l, jsx as v } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          d: "M17.917 33.002h-3.996v3.996h3.996v-3.996ZM25.958 33.002h-3.996v3.996h3.996v-3.996ZM33.999 33.002h-3.996v3.996h3.996v-3.996ZM17.917 40.962h-3.996v3.996h3.996v-3.996ZM25.958 40.962h-3.996v3.996h3.996v-3.996ZM33.999 40.962h-3.996v3.996h3.996v-3.996ZM46.857 35.743c-6.138 0-11.114 4.975-11.114 11.114 0 6.139 4.975 11.114 11.114 11.114 6.139 0 11.114-4.975 11.114-11.114 0-6.139-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M42.04 34.663v-1.66h-3.996v3.996h.179a13.11 13.11 0 0 1 3.817-2.335v-.001Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          d: "M51.893 45.85h-4.029v-4.03l-2.015.54v3.489h-4.03l.54 2.015h3.489v4.029h2.015v-4.029h4.029v-2.015l.001.001Z"
        }
      ),
      /* @__PURE__ */ v(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M34.794 51.998h-24.77V28.004h43.951v7.844a13.228 13.228 0 0 1 3.996 4.056V15.019H43.987V9.026h-3.996v5.993H24.009V9.026h-3.996v5.993h-9.984a4 4 0 0 0-4 4v32.975a4 4 0 0 0 4 4h27.433a13.144 13.144 0 0 1-2.667-3.997l-.001.001Zm-24.77-32.984h9.989v3.992l3.996-1.075v-2.917h15.982v3.992l3.996-1.075v-2.917h9.989v6.992H10.024v-6.992Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  o as CreatePaymentSchedule
};
